import { Component, OnInit, Input } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditModuleListModel } from 'app/audit/models/audit-module-list.model';
import { Result } from 'app/core/models/result';

@Component({
    selector: 'app-audit-module-list',
    templateUrl: './audit-module-list.component.html',
    styleUrls: ['./audit-module-list.component.css']
})
export class AuditModuleListComponent implements OnInit {
    @Input() auditId: string;
    @Input() isEditMode: boolean = false;
    selectedModuleId: string;
    errors: string[];
    auditModules: AuditModuleListModel[];

    constructor(
        private auditService: AuditService
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.auditService.getAuditModules(this.auditId).subscribe(
            auditModules => {
                this.auditModules = auditModules;
            },
            error => this.errors = error.errorList
        );
    }

    onAuditModuleAdded($event): void {
        this.load();
    }

    deleteAuditModules(): void {
        this.auditService.deleteAuditModule(this.auditId, this.selectedModuleId).subscribe(
            result => this.load(),
            error => this.errors = (<Result>error).errorList
        );
    }
}
